import { render, staticRenderFns } from "./CheckoutPaymentPayPal.vue?vue&type=template&id=21449a3c&scoped=true&"
import script from "./CheckoutPaymentPayPal.vue?vue&type=script&lang=js&"
export * from "./CheckoutPaymentPayPal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21449a3c",
  null
  
)

export default component.exports